export default "__VITE_ASSET__B8r0f3b0__"